import React from 'react';
import { MapIcon, LocationIcon } from '../Icons/Icons';
import './LocationSection.css';

function LocationSection({ location, nearbyPlaces }) {
  return (
    <div className="location-section">
      <h2 className="section-title">Location & Nearby</h2>

      <div className="map-placeholder">
        <div className="map-overlay">
          <MapIcon size={48} color="var(--color-primary)" />
          <p className="map-text">Interactive Map</p>
          <p className="map-subtext">{location}</p>
        </div>
      </div>

      {nearbyPlaces && nearbyPlaces.length > 0 && (
        <div className="nearby-places">
          <h3 className="nearby-title">Nearby Landmarks</h3>
          <div className="nearby-list">
            {nearbyPlaces.map((place, index) => (
              <div key={index} className="nearby-item">
                <span className="nearby-icon">
                  <LocationIcon size={20} color="var(--color-primary)" />
                </span>
                <div className="nearby-content">
                  <div className="nearby-name">{place.name}</div>
                  <div className="nearby-distance">{place.distance}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default LocationSection;
